import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './requisition-list.routing';
import {RequisitionListComponent} from './requisition-list.component';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {Daterangepicker} from 'ng2-daterangepicker';
import {AutoCompleteModule, ConfirmDialogModule, DialogModule, PanelModule} from 'primeng/primeng';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SafeUrlModule} from '../../shared/custom-pipe/safe-url.module';
import {NgxBarcodeModule} from 'ngx-barcode';
import {RequisitionListService} from './requisition-list.service';



@NgModule ({
    imports: [
        CommonModule, SharedTranslationModule,
        FormsModule,
        ReactiveFormsModule,
        Daterangepicker,
        NgxBarcodeModule,
        SharedTranslationModule,
        ConfirmDialogModule,
        DialogModule,
        AutoCompleteModule,
        PanelModule,

        SafeUrlModule,
        routing
    ],
    declarations: [RequisitionListComponent],
    providers: [
    RequisitionListService
]
})
export class RequisitionListModule {
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/requisition-list/requisition-list.module.ts